import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=da026010&scoped=true&"
import script from "./EventDialog.vue?vue&type=script&lang=js&"
export * from "./EventDialog.vue?vue&type=script&lang=js&"
import style0 from "./EventDialog.vue?vue&type=style&index=0&id=da026010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da026010",
  null
  
)

component.options.__file = "EventDialog.vue"
export default component.exports